<template>
  <div class="countdown-timer">
    <svg
      class="countdown-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z"
        :fill="getColor('primary')"
      />
    </svg>
    <span class="countdown-time text-primary">{{ formattedTime }}</span>
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    remainingTime: {
      type: Number,
      required: true,
      validator: value => value >= 0,
    },
  },
  data() {
    return {
      timer: null,
      currentTime: this.remainingTime,
    }
  },
  computed: {
    formattedTime() {
      const totalSeconds = Math.floor(this.currentTime)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
  },

  watch: {
    remainingTime(newVal) {
      this.currentTime = newVal
      this.startCountdown()
    },
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    startCountdown() {
      if (this.timer) clearInterval(this.timer)
      if (this.currentTime <= 0) return
      this.timer = setInterval(() => {
        if (this.currentTime > 0) {
          this.currentTime -= 1
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.$emit('finished')
        }
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.countdown-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  position: relative;
  .countdown-time {
    text-align: right;
    font-family: IRANSansXFaNum, -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    position: relative;
    margin-top: 3px;
  }

  .countdown-icon {
    width: 24px;
    height: 24px;
    position: relative;
    flex-shrink: 0;
  }
}

</style>
